import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminCommonService } from '../../../../../services/admin/admin-common.service';
import { AdminSatelliteService } from '../../../../../services/admin/admin-satellite.service';
import { selectAction } from '../../../../../shared/state/index.state';
import { SatelliteOtherDetails } from '../admin-satellite-surveillance.model';
import { SatelliteSurveillanceActions } from './satellite-surveillance.actions';
import { SatelliteSurveillanceState } from './satellite-surveillance.state';

/**
 * https://www.intertech.com/Blog/ngrx-tutorial-actions-reducers-and-effects/
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class SatelliteSurveillanceEffect {

    constructor(private actions$: Actions,
                private modalService: BsModalService,
                private adminSatelliteService: AdminSatelliteService,
                private adminCommonService: AdminCommonService) {
        // this.listenToRouter();
    }

    @Effect() getSatelliteSurveillance$ = this.actions$
        .pipe(
            selectAction(SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE),
            switchMap(() =>
                this.adminSatelliteService.getSatelliteSurveillance()
                    .pipe(
                        map((satellites: SatelliteSurveillanceState) =>
                            SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE_SUCCESS(satellites)
                        ),

                        catchError(error =>
                            of(SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE_FAIL({error}))
                        )
                    )
            )
        );

    @Effect() getSatelliteOtherDetails$ = this.actions$
        .pipe(
            selectAction(SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS),
            switchMap(satellite =>
                this.adminSatelliteService.getSatelliteOtherDetails(satellite.payload.satelliteId, satellite.payload.autoremindAccount)
                    .pipe(
                        map((otherDetails: SatelliteOtherDetails) =>
                            SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS_SUCCESS(otherDetails)
                        ),

                        catchError(error =>
                            of(SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS_FAIL({error}))
                        )
                    )
            )
        );

}
